export const SMALL_SCREEN_SIZE_BREAKPOINT = 1024;
